import React from 'react'
import Icon from '../components/Icon'
import ItemGrid from '../components/ItemGrid'
import ItemList from '../components/ItemList'
import ItemFull from '../components/ItemFull'

const displayModes = {
	LIST: {
		type: 'LIST',
		icon: <Icon name="blackList" />,
		iconActive: <Icon name="redList" />,
		component: ItemList
	},
	GRID: {
		type: 'GRID',
		icon: <Icon name="blackGrid" />,
		iconActive: <Icon name="redGrid" />,
		component: ItemGrid
	},
	FULL: {
		type: 'FULL',
		icon: <Icon name="blackFeed" />,
		iconActive: <Icon name="redFeed" />,
		component: ItemFull
	}
}

export const allDisplayModes = Object.keys(displayModes).map(mode => displayModes[mode].type)

export default displayModes



// WEBPACK FOOTER //
// ./src/enums/displayModes.js